import { defineComponent as r, createBlock as n, openBlock as a, unref as p, mergeProps as i, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as l } from "@ds/components/Icon";
const w = /* @__PURE__ */ r({
  name: "IconArrowDownRight",
  __name: "IconArrowDownRight",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (s, e) => (a(), n(p(l), i(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        c("path", { d: "M6.166 5.106a.75.75 0 1 0-1.06 1.06l11.447 11.448h-5.26a.75.75 0 1 0 0 1.5h6.57a1.25 1.25 0 0 0 1.25-1.25v-6.571a.75.75 0 0 0-1.5 0v5.26L6.167 5.106" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  w as default
};
